/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Placeholder, PlaceholderImage } from 'semantic-ui-react'

const CardLoadingPlaceholder = ({ ...props }) => {
    return (
      <Placeholder
        css={css`
            width: 100%;
            height: 100%;
        `}
        className={props.className}
      >
          <PlaceholderImage/>
      </Placeholder>
    )
}

export { CardLoadingPlaceholder }
